module.exports = __webpack_public_path__ + "static/img/invite.dc2319cc.png";